import React, { useState, useEffect } from 'react'
import './user-role-table-view.scss';
import Calender from '../../../../assets/images/calendar.svg';
import Grid from '../../../../assets/images/grid.svg';
export const UserRoleTableView = ({ onViewChange, onCalendarClick, selectedView = 'task' }) => {
  const [isCalendarClicked, setIsCalendarClicked] = useState(false);

  // Reset calendar state when view changes
  useEffect(() => {
    setIsCalendarClicked(false);
    if (onCalendarClick) {
      onCalendarClick(false);
    }
  }, [selectedView]);

  const handleClick = (viewType) => {
    if (selectedView !== viewType && onViewChange) {
      onViewChange(viewType);
    }
  };

  const handleCalendarClick = () => {
    const newValue = !isCalendarClicked;
    setIsCalendarClicked(newValue);
    if (onCalendarClick) {
      onCalendarClick(newValue);
    }
  };

  return (
    <div className="view-options">
      <div className="user-role-table__view">
        <ul>
          <li
            className={selectedView === 'task' ? 'active' : ''}
            onClick={() => handleClick('task')}
          >
            Task
          </li>
          <li
            className={selectedView === 'enquiry' ? 'active' : ''}
            onClick={() => handleClick('enquiry')}
          >
            Enquiry
          </li>
        </ul>

      </div>

      {selectedView === 'task' && (
        <div className="calender-view" onClick={handleCalendarClick}>
          <img src={isCalendarClicked ? Grid : Calender} alt={isCalendarClicked ? "grid" : "calendar"} />
        </div>
      )}
    </div>

  )
}
export default UserRoleTableView;